import { ReactNode } from 'react';
import { ProcessorButton } from './view';

interface Props {
    onClick: () => void;
    children?: ReactNode;
    disabled?: boolean;
    isSelected?: boolean;
}

export const VirtualBackgroundProcessorButton = ({ onClick, children, disabled, isSelected }: Props) => {
    return (
        <ProcessorButton onClick={onClick} disabled={disabled} $isSelected={isSelected}>
            {children}
        </ProcessorButton>
    );
};
